import { Directive, Host, Input, OnDestroy, Optional } from '@angular/core';
import { Unsubscribable } from 'rxjs';
import { GridTableComponent } from '../grid/grid-table/grid-table.component';
import { GridExpandCollapseButtonComponent } from './grid-expand-collapse-button.component';

// Temporary for setting grid while supporting both grids
@Directive({
  selector: 'app-grid-table[expandCollapseButton]',
  standalone: false,
})
export class GridExpandCollapseButtonDirective<T extends {}> implements OnDestroy {
  @Input() set expandCollapseButton(value: GridExpandCollapseButtonComponent<T>) {
    this._subscription?.unsubscribe();
    if (value) {
      this._subscription = value.register(this.grid);
    }
  }

  get grid() {
    if (!this.gridTable) {
      throw new Error('No grid');
    }
    return this.gridTable;
  }

  private _subscription?: Unsubscribable;

  constructor(@Host() @Optional() private gridTable?: GridTableComponent<T>) {}

  ngOnDestroy() {
    this._subscription?.unsubscribe();
  }
}
